/// <amd-dependency path='VSS/LoaderPlugins/Css!WorkItemArea' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import * as SelectWorkItemView from "TestManagement/Scripts/TFS.TestManagement.SelectWorkItemView"
import * as Resources from "TestManagement/Scripts/Resources/TFS.Resources.TestManagement";
import * as TestsOM from "TestManagement/Scripts/TFS.TestManagement";
import * as Dialogs  from "VSS/Controls/Dialogs";

export interface IAddToExistingTestCasesDialogProps {
    okCallback(testCaseIds: number[]): void;
    areaPath: string;
}

// This is a proxy component to load the add existing test case dialog using LegacyComponent
class AddToExistingTestCasesProxy extends React.Component<IAddToExistingTestCasesDialogProps, {}>{
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        Dialogs.show(SelectWorkItemView.SelectWorkItemsDialog, {
            width: $(window).width() * 0.8,
            height: $(window).height() * 0.8,
            attachResize: true,
            okText: Resources.AddTestCases,
            okCallback: (testCaseIds: number[]) => {
                this.props.okCallback(testCaseIds);
            },
            title: Resources.AddTestCasesToSuite.toLocaleUpperCase(),
            workItemCategories: [TestsOM.WorkItemCategories.TestCase],
            hideQueryType: false,
            persistenceId: SelectWorkItemView.PersistenceIds.ADD_TEST_CASES_ID,
            supportWorkItemOpen: true,
            areaPath: this.props.areaPath
        }).setInitialFocus();
    }
}

registerLWPComponent("add-to-existing-dialog-proxy", AddToExistingTestCasesProxy);